import React from 'react'
import { Box, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Trans } from 'gatsby-plugin-react-i18next'
import useTrustPilot from '../../hooks/useTrustPilot'
import PngTrustPilotLogoBlack from '../../images/trustpilot-logo-black.png'
import TrustPilotStarRating from '../TrustPilot/TrustPilotStarRating'

interface Props {
  containerClass?: string
  row?: boolean
}

const FiveStarColumn: React.FC<Props> = ({ containerClass, row = false }) => {
  const { classes, cx } = useStyles()
  const trustPilot = useTrustPilot()
  const fiveStars = trustPilot?.businessUnit?.numberOfReviews?.fiveStars
    ? trustPilot.businessUnit.numberOfReviews.fiveStars
    : 800
  const roundedFiveStars = Math.floor(fiveStars / 50) * 50

  if (!trustPilot) {
    return null
  }

  return (
    <Box
      sx={{ display: 'flex' }}
      className={cx({
        [classes.box]: true,
        [classes.row]: !!row,
        //@ts-ignore
        [containerClass]: !!containerClass,
      })}
      component="a"
      //@ts-ignore
      href={trustPilot.links.profileUrl}
    >
      <TrustPilotStarRating iconClass={classes.starIcon} rating={5} />
      <Typography className={classes.typography} variant="body2">
        <Trans
          i18nKey="trustpilot.fiveStars"
          values={{
            reviews: roundedFiveStars,
          }}
          components={{
            /* eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content */
            strong: <strong />,
          }}
        />
      </Typography>
      <img
        className={cx({ [classes.logo]: row })}
        src={PngTrustPilotLogoBlack}
        alt="Trustpilot logo"
      />
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  box: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    textDecoration: 'none',
  },
  logo: {
    height: '1.8em',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'center',

    '& > *': {
      margin: '0 .5em',
    },

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',

      '& > *': {
        margin: '.5em 0',
      },
    },
  },
  starIcon: {
    height: '1.4rem',
  },
  typography: {
    color: theme.palette.text.primary,
    textDecoration: 'none',
  },
}))

export default FiveStarColumn
